import { useState } from "react"
import './index.css'
import { useNavigate } from "react-router-dom"
import { changeUserPassword } from "../../services/user.service"
import InputLabel from "../common/InputLabel"
import InputPassword, { PasswordValidation } from "../common/InputPassword"
import ActionButton from "../common/ActionButton"
import { userPasswordChangeForm } from "../../models/user.model"
import useUser from "../../hooks/useUser"
import { useNotification } from "../../context/NotificationContext"


interface UserPasswordChangeProps {
  setBlockScreen: (param: boolean) => void
}

export default function UserPasswordChange({ setBlockScreen }: UserPasswordChangeProps) {

  const { showNotification } = useNotification();
  const navigate = useNavigate()
  const { user } = useUser()

  const [userPasswordForm, setUserPasswordForm] = useState<userPasswordChangeForm>({
    name: `${user.name} ${user.last_name}`,
    username: user.username,
    current_password: '',
    new_password: '',
    confirm_password: ''
  })

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setUserPasswordForm({
      ...userPasswordForm,
      [event.target.name]: event.target.value
    });
  }

  const handleSubmit = () => {
    setBlockScreen(true)
    Promise.all([changeUserPassword(userPasswordForm)])
      .then((results) => {
        setBlockScreen(false)
        navigate('/')
      })
      .catch((error) => {
        showNotification(error.response.data, 'error')
        setBlockScreen(false)
      })
  }

  const [validationPassword, setValidationPassword] = useState<boolean>(false)

  return (<>
    <div className='user-password-change-box-wrap'>
      <div className='user-password-change-box'>
        <div className="user-password-change-title">
          <div>
            Elige un password
          </div>
        </div>

        <form className="user-password-change-fields">

          <InputLabel
            label='Nombre'
            value={userPasswordForm.name}
            disabled
          />

          <InputLabel
            label='Username'
            value={userPasswordForm.username}
            disabled
          />

          <InputPassword
            label='Contraseña actual'
            name='current_password'
            value={userPasswordForm.current_password}
            onChange={handleChange}
            showEye
          />

          <InputPassword
            label='Nueva contraseña'
            name='new_password'
            value={userPasswordForm.new_password}
            onChange={handleChange}
            showEye
          />

          <InputPassword
            label='Confirma nueva contraseña'
            name='confirm_password'
            value={userPasswordForm.confirm_password}
            onChange={handleChange}
            showEye
          />

          <span className="user-password-change-validation">
            <PasswordValidation
              inputPassword={userPasswordForm.new_password}
              confirmPassword={userPasswordForm.confirm_password}
              setValidationSuccess={setValidationPassword}
            />
          </span>
        </form>

        <span>
          <ActionButton
            text="Confirmar"
            type="confirm"
            onClick={handleSubmit}
            disabled={!validationPassword || userPasswordForm.current_password.length === 0}
          />
        </span>

      </div>
    </div>

  </>)
}